'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

require('cropper');

const Translator = require('./../../../core/translator');
const PopinManager = require('./../../../services/popin');
const SaveManager = require('./../component/SaveManager');
const DndZone = require('./../service/dndZone');
const ResizeColumn = require('./../service/resizeColumn');
const HighlightContent = require('./../service/highlightContent');
const Loader = require('./../../../services/loader');
const Formbuilder = require('./../../../services/form');
const Help = require('./../../../services/help');
const mediator = require('./../../../core/mediator');

const createPopin = function($btn, onOk, onCancel) {
    let direction = ($btn.offset().left + 200 + 20) < jQuery('body').outerWidth() ? 'left' : 'right';
    let popin = PopinManager.createPopin({
        'title': Translator.translate('background_options'),
      'classes': {
        'ui-dialog': 'cloud-dialog prevent-click row-settings-popin',
      },

        'width': 430,
        'minHeight': 530,
        'appendTo': '#cloud-ui',
        'position': {my: direction + ' bottom-15', at: direction + ' top', of: $btn},
        'buttons': [
            {
                class: 'popin popin-cancel',
                text: Translator.translate('discard'),
                click: onCancel,
            },
            {
                class: 'popin popin-ok',
                text: Translator.translate('submit'),
                click: onOk,
            },
        ],
    });

    return popin;
};

const updateHelp = (popin, helpName) => {
    let $link = Help.createLink(helpName);
    let $title = popin.rootElement.parent().find('.ui-dialog-titlebar:first').find('.ui-dialog-title:first');

    $title.find('.cloud-help-link').remove();
    $link.addClass('popin');
    $title.append($link);
};

module.exports.showForm = function(cloudContentSet) {
    let form;
    let onOk = () => {
        form.submit();
    };
    let onCancel = () => {
        Loader.start(popin.rootElement);
        cloudContentSet.refresh().done(function() {
            mediator.publish('on:row-settings:submit');
            Loader.stop(popin.rootElement);
            popin.hide();
        });
    };

    let popin = createPopin(cloudContentSet.$.find('.row-settings'), onOk, onCancel);
    let $container = jQuery('<div></div>');

    popin.setContent($container);

    popin.on('open', function() {
        cloud.disableUi();
        updateHelp(popin, `row_settings_style`);

        HighlightContent.start(cloudContentSet.$);
    });

    popin.on('close', function() {
        cloud.enableUi();
        HighlightContent.stop(cloudContentSet.$);
    });

    popin.display();

    Loader.start(popin.rootElement);

    cloudContentSet.getData(null, true).done(function() {
        const checkParallax = function() {
            const $cropperElement = $container.find('.element_bg_image');
            const isParallax = this ? jQuery(this)[0].checked : ($container.find('input[type=checkbox][name=bg_parallax]').is(':checked'));

            $cropperElement[isParallax ? 'addClass' : 'removeClass']('disabled');

            return isParallax;
        };

        // const onChangeParallax = function() {
        //     const imageParallax = cloudContentSet.$.data('bb-image');
        //     const isParallax = checkParallax();

        //     if (!isParallax && imageParallax) {
        //         cloudContentSet.$.css({
        //             'background-image': 'url(' + imageParallax + ')',
        //             'background-size': 'cover',
        //         });
        //     }
        // };

        const onCrop = function(e, $img, positionY) {
            cloudContentSet.$.css('background-position-y', positionY + '%');
        };

        const onSubmitVideo = function(inputVal) {
            let bgImageElement = form.elements['bg_image'];
            let $errorMsg = form.elements['bg_video'].$.find('.form-error');
            let $buttonRemove = bgImageElement.$.find('.remove');
            let $labelNoImage = bgImageElement.$.find('.image-wrapper').find('.label-no-image');
            const hasImage = bgImageElement.$.find('.image-wrapper').find('img:first').attr('src');
            const youtubeUrlRegex = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

            $errorMsg.addClass('d-none');
            if (inputVal) {
                let validYoutubeUrl = inputVal.match(youtubeUrlRegex);

                if (validYoutubeUrl) {
                    $errorMsg.addClass('d-none');

                    let youtubeId = validYoutubeUrl[1];
                    let thumbnailYoutube = 'https://img.youtube.com/vi/' + youtubeId + '/maxresdefault.jpg';

                    bgImageElement.afterUpload(thumbnailYoutube);

                    if ($labelNoImage.length === 1) {
                        $labelNoImage.remove();
                    }
                } else {
                    $errorMsg.removeClass('d-none');

                    if (hasImage) {
                        $buttonRemove.removeClass('d-none').addClass('d-inline');
                    }
                }
            } else if (!inputVal && hasImage) {
                $buttonRemove.removeClass('d-none').addClass('d-inline');
                if (hasImage.includes('youtube')) {
                   $buttonRemove.trigger('click');
                }
            }
        };

        const onBuilt = function($img, e) {
            let $current = jQuery(this);
            let positionY;
            let data = $current.cropper('getData');
            let imageData = $current.cropper('getImageData');

            const imageParallax = cloudContentSet.$.data('bb-image');

            if (imageParallax) {
                positionY = parseFloat(cloudContentSet.$.data('bg-y'));
            } else {
                let position = cloudContentSet.$.css('background-position').split(' ');
                positionY = parseFloat(position[1]);
            }

            let y = (positionY * (imageData.naturalHeight - data.height)) / 100;
            $current.cropper('setData', {'y': y});

            const hasImage = form.elements['bg_image'].$.find('.image-wrapper').find('img:first').attr('src');
            const hasVideo = form.elements['bg_video'].$.find('input').val();

            if (hasImage && !hasVideo) {
                form.elements['bg_image'].$.find('.remove').removeClass('d-none');
            }
        };

        const onUpload = function(data) {
            cloudContentSet.$.css({
                'background-image': 'url(' + data.url + ')',
                'background-size': 'cover',
            });

            $container.find('input[type=checkbox][name=bg_parallax]').attr('disabled', false).closest('.cloud-form-control').removeClass('disabled');
            checkParallax();

            DndZone.apply();
            ResizeColumn.apply();
        };

        const onDeleteUpload = function() {
            const imageParallax = cloudContentSet.$.data('bb-image');

            if (imageParallax) {
                jQuery('.parallax-mirror img[src="' + imageParallax + '"]').parent().remove();
            }
            cloudContentSet.$.css('background-image', 'none');
            $container.find('input[type=checkbox][name=bg_parallax]').attr('checked', false).attr('disabled', true).closest('.cloud-form-control').addClass('disabled');
        };

        const onTabCropChange = function(ratio) {
            return cloudContentSet.$.outerWidth() / cloudContentSet.$.outerHeight();
        };

        const onChangeColor = function(colorClass) {
            cloudContentSet.$.removeAttr('style');
            _.forEach(cloudContentSet.$.attr('class').split(' '), function(classname) {
                if (-1 !== classname.indexOf('color-')) {
                    cloudContentSet.$.removeClass(classname);
                }
            });

            if (colorClass) {
                cloudContentSet.$.addClass('has-bg-color ' + colorClass);
            }
        };

        const onChangeOverlay = function(checked) {
            cloudContentSet[checked ? 'addClass' : 'removeClass']('row-overlay');
        };

        const onChangeBlur = function(checked) {
            cloudContentSet[checked ? 'addClass' : 'removeClass']('bg-blur');
        };

        const onChangeGutter = function(checked) {
            cloudContentSet.$.find('.row:first')[checked ? 'addClass' : 'removeClass']('no-gutter');
        };

        const onChangePadding = function(checked) {
            cloudContentSet.$[checked ? 'addClass' : 'removeClass']('p-0');

            if (form.$) {
                form.$.find('.element_height')[checked ? 'addClass' : 'removeClass']('d-none');
            }
        };

        const onChangeWidth = function(newClass) {
            let $container = cloudContentSet.$.children().not('.btn-row-settings');

            $container.removeAttr('class').addClass(newClass);
        };

        const onChangeHeight = function(step) {
            let currentPaddingTop = parseInt(cloudContentSet.$.css('padding-top').replace('px', ''), 10);
            let currentPaddingBottom = parseInt(cloudContentSet.$.css('padding-bottom').replace('px', ''), 10);

            if (!step) {
                return;
            }

            cloudContentSet.$.css('padding-top', currentPaddingTop + step + 'px');
            cloudContentSet.$.css('padding-bottom', currentPaddingBottom + step + 'px');
        };

        const onChangeVerticalAlign = function(checked) {
            cloudContentSet[checked ? 'addClass' : 'removeClass']('align-item-center');
        };

        form = Formbuilder.getForm({
            'elements': {
                'bg_color': {
                    'label': 'background_color',
                    'type': 'color',
                    'value': cloudContentSet.getParameter('bg_color').value,
                    'tab': 'media',
                    'onChange': onChangeColor,
                    'group': {
                        'id': 'bg-color',
                    },
                },
                'bg_video': {
                    'label': 'background_video',
                    'type': 'textButton',
                    'value': cloudContentSet.getParameter('bg_video').value,
                    'tab': 'media',
                    'placeholder': 'youtube_video_url',
                    'message': 'url_error',
                    'onSubmit': onSubmitVideo,
                    'group': {
                        'id': 'bg-video',
                    },
                },
                'bg_image': {
                    'label': 'background_image',
                    'type': 'crop',
                    'value': {
                        'image': cloudContentSet.getParameter('bg_image').value,
                        'positionY': parseFloat(cloudContentSet.getParameter('bg_image_position_y').value.replace('%', '')),
                    },
                    'tab': 'media',
                    'ratio': cloudContentSet.$.outerWidth() / cloudContentSet.$.outerHeight(),
                    'onCrop': onCrop,
                    'onBuilt': onBuilt,
                    'onUpload': onUpload,
                    'onDelete': onDeleteUpload,
                    'onTabChange': onTabCropChange,
                    'group': {
                        'id': 'bg-image',
                    },
                },
                // 'bg_parallax': {
                //     'label': 'background_parallax',
                //     'type': 'switch',
                //     'value': cloudContentSet.getParameter('bg_parallax').value,
                //     'tab': 'media',
                //     'onChange': onChangeParallax,
                // },
                'bg_overlay': {
                    'label': 'background_overlay',
                    'type': 'switch',
                    'value': cloudContentSet.getParameter('bg_overlay').value,
                    'tab': 'media',
                    'onChange': onChangeOverlay,
                    'group': {
                        'id': 'bg-other',
                    },
                },
                'bg_blur': {
                    'label': 'background_blur',
                    'type': 'switch',
                    'value': cloudContentSet.getParameter('bg_blur').value,
                    'tab': 'media',
                    'onChange': onChangeBlur,
                    'group': {
                        'id': 'bg-other',
                    },
                },
                'width': {
                    'label': 'column_width',
                    'type': 'containerWidth',
                    'value': cloudContentSet.getParameter('width').value,
                    'tab': 'marge',
                    'group': {'id': 'width'},
                    'onChange': onChangeWidth,
                },
                'remove_gutter': {
                    'label': 'remove_gutter',
                    'type': 'switch',
                    'value': cloudContentSet.getParameter('remove_gutter').value,
                    'tab': 'marge',
                    'group': {'id': 'width'},
                    'onChange': onChangeGutter,
                },
                'height': {
                    'label': 'column_height',
                    'type': 'height',
                    'default_value': 8,
                    'value': cloudContentSet.getParameter('height').value,
                    'tab': 'marge',
                    'wrap_class': cloudContentSet.getParameter('remove_padding').value ? 'd-none' : '',
                    'onChange': onChangeHeight,
                    'group': {'id': 'margin'},
                },
                'remove_padding': {
                    'label': 'remove_padding',
                    'type': 'switch',
                    'value': cloudContentSet.getParameter('remove_padding').value,
                    'tab': 'marge',
                    'onChange': onChangePadding,
                    'group': {'id': 'margin'},
                },
                'vertical_align': {
                    'label': 'vertical_align',
                    'type': 'switch',
                    'value': cloudContentSet.getParameter('vertical_align').value,
                    'tab': 'marge',
                    'onChange': onChangeVerticalAlign,
                },
                'row_id': {
                    'label': 'row_id',
                    'type': 'text',
                    'value': '#row_' + cloudContentSet.data.uid,
                    'copyText': true,
                    'readonly': true,
                    'tab': 'anchor',
                },
                'button_collapse_enable': {
                    'type': 'switch',
                    'label': Translator.translate('row_button_collapse_enable'),
                    'value': cloudContentSet.getParameter('button_collapse_enable').value,
                    'tab': 'display',
                    'group': {
                        'id': 'btn_collapse',
                        'title': 'collapse_btn',
                    },
                },
                'button_collapse_color': {
                    'type': 'color',
                    'label': Translator.translate('row_button_collapse_color'),
                    'value': cloudContentSet.getParameter('button_collapse_color').value,
                    'disable_transparent': true,
                    'tab': 'display',
                    'group': {'id': 'btn_group'},
                },
                'button_collapse_form_solid': {
                    'type': 'switch',
                    'label': 'row_button_collapse_solid_color',
                    'value': cloudContentSet.getParameter('button_collapse_form_solid').value,
                    'tab': 'display',
                    'group': {'id': 'btn_group'},
                },
                'button_collapse_size': {
                    'type': 'select',
                    'label': 'row_button_collapse_size',
                    'options': {
                                'sm': 'row_button_collapse_small',
                                'md': 'row_button_collapse_medium',
                                'lg': 'row_button_collapse_large',
                            },
                    'value': cloudContentSet.getParameter('button_collapse_size').value,
                    'tab': 'display',
                    'group': {'id': 'btn_group'},
                },
                'nb_item_max_mobile': {
                    'label': 'responsive_mobile',
                    'type': 'select',
                    'value': cloudContentSet.getParameter('responsive_mobile').value['nb_item_max'] || '4',
                    'options': {
                        '4': Translator.translate('responsive_number_of_content') + ': 4',
                        '3': Translator.translate('responsive_number_of_content') + ': 3',
                        '2': Translator.translate('responsive_number_of_content') + ': 2',
                        '1': Translator.translate('responsive_number_of_content') + ': 1',
                        '0': Translator.translate('responsive_number_of_content') + ': 0',
                    },
                    'tab': 'display',
                    'group': {
                        'id': 'mobile',
                        'description': 'responsive_description',
                        'title': 'mobile_display',
                    },
                },
                'nb_item_mobile': {
                    'type': 'select',
                    'value': cloudContentSet.getParameter('responsive_mobile').value['nb_item'],
                    'options': {
                        '4': Translator.translate('responsive_number_of_content_side_by_side') + ': 4',
                        '3': Translator.translate('responsive_number_of_content_side_by_side') + ': 3',
                        '2': Translator.translate('responsive_number_of_content_side_by_side') + ': 2',
                        '1': Translator.translate('responsive_number_of_content_side_by_side') + ': 1',
                    },
                    'tab': 'display',
                    'group': {'id': 'mobile'},
                },
                'nb_item_max_tablet': {
                    'label': 'responsive_tablet',
                    'type': 'select',
                    'value': cloudContentSet.getParameter('responsive_tablet').value['nb_item_max'] || '4',
                    'options': {
                        '4': Translator.translate('responsive_number_of_content') + ': 4',
                        '3': Translator.translate('responsive_number_of_content') + ': 3',
                        '2': Translator.translate('responsive_number_of_content') + ': 2',
                        '1': Translator.translate('responsive_number_of_content') + ': 1',
                        '0': Translator.translate('responsive_number_of_content') + ': 0',
                    },
                    'tab': 'display',
                },
                'nb_item_tablet': {
                    'type': 'select',
                    'value': cloudContentSet.getParameter('responsive_tablet').value['nb_item'],
                    'options': {
                        '4': Translator.translate('responsive_number_of_content_side_by_side') + ': 4',
                        '3': Translator.translate('responsive_number_of_content_side_by_side') + ': 3',
                        '2': Translator.translate('responsive_number_of_content_side_by_side') + ': 2',
                        '1': Translator.translate('responsive_number_of_content_side_by_side') + ': 1',
                    },
                    'tab': 'display',
                },
            },
            'form': {
                'submit_class': 'd-none',
                'onChangeTab': (tab) => {
                    updateHelp(popin, `row_settings_${tab}`);
                },
            },
        });

        form.on('submit', function(data) {
            Loader.start(popin.rootElement);

            cloudContentSet.addParameter('width', data.width);
            cloudContentSet.addParameter('height', data.height);
            cloudContentSet.addParameter('bg_color', data.bg_color);
            cloudContentSet.addParameter('bg_image', data['bg_image']['image']);
            cloudContentSet.addParameter('bg_image_position_y', (data['bg_image']['positionY'] || '0') + '%');
            cloudContentSet.addParameter('responsive_mobile', {
                'nb_item': data['nb_item_mobile'],
                'nb_item_max': data['nb_item_max_mobile'],
            });
            cloudContentSet.addParameter('responsive_tablet', {
                'nb_item': data['nb_item_tablet'],
                'nb_item_max': data['nb_item_max_tablet'],
            });
            cloudContentSet.addParameter('remove_gutter', data['remove_gutter']);
            cloudContentSet.addParameter('remove_padding', data['remove_padding']);
            cloudContentSet.addParameter('bg_overlay', data['bg_overlay']);
            cloudContentSet.addParameter('bg_blur', data['bg_blur']);
            cloudContentSet.addParameter('bg_parallax', data['bg_parallax']);
            cloudContentSet.addParameter('bg_video', data['bg_video']);
            cloudContentSet.addParameter('vertical_align', data['vertical_align']);
            cloudContentSet.addParameter('button_collapse_enable', data['button_collapse_enable']);
            cloudContentSet.addParameter('button_collapse_color', data['button_collapse_color']);
            cloudContentSet.addParameter('button_collapse_form_solid', data['button_collapse_form_solid']);
            cloudContentSet.addParameter('button_collapse_size', data['button_collapse_size']);

            SaveManager.save().done(function() {
                if (cloudContentSet.getParameter('bg_parallax')) {
                    cloudContentSet.refresh().done(function() {
                        mediator.publish('on:row-settings:submit');
                        if (typeof window.refreshParallax === 'function') {
                            window.refreshParallax();
                        }
                    });
                } else {
                    mediator.publish('on:row-settings:submit');
                }

                popin.hide();
            });
        });


        $container.append(form.render());
        let bgImageUrl = cloudContentSet.getParameter('bg_image').value;
        if (bgImageUrl === '' || bgImageUrl.includes('youtube')) {
            $container.find('input[type=checkbox][name=bg_parallax]').attr('disabled', true).closest('.cloud-form-control').addClass('disabled');
        }
        checkParallax();

        let $collapseBtn = form.$.find('.element_button_collapse_enable');
        let $buttonParameters = form.$.find('.group.btn_group');

        if ($collapseBtn.length === 1) {
            if (!$collapseBtn.find('input')[0].checked) {
                    $buttonParameters.addClass('d-none');
            }

            $collapseBtn.find('label.cloud-form-control').on('change', function() {
                $collapseBtn.find('input')[0].checked ? $buttonParameters.removeClass('d-none') : $buttonParameters.addClass('d-none');
            });
        }

        Loader.stop(popin.rootElement);
    });
};

module.exports.beforePopinOpen = function(config) {
  if (config.$popin.dialog('option', 'classes.ui-dialog').includes('row-settings-popin')) {
        config.blur = false;
    }
};
